"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constellation_1 = require("@zillow/constellation");
const react_1 = __importDefault(require("react"));
const PersonalizedRateCard_1 = __importDefault(require("./PersonalizedRateCard"));
const RateCard_1 = __importDefault(require("./RateCard"));
const RateCardsContainer = ({ cardsInfo }) => (react_1.default.createElement(constellation_1.Grid, { display: "grid", gridTemplateColumns: {
        default: 'repeat(3, 4fr)',
        xl: 'repeat(3, 4fr)',
        lg_lte: 'repeat(2, 6fr)',
    }, gap: "sm" },
    cardsInfo.map((card) => (react_1.default.createElement(RateCard_1.default, { ...card, key: card.title }))),
    react_1.default.createElement(PersonalizedRateCard_1.default, null)));
exports.default = RateCardsContainer;
